import { MarkdownModule } from 'ngx-markdown';

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { LetDirective } from '@ngrx/component';

import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';

import { DefaultSessionComponentFragment } from '@fms/ngx-gql-client';
import { ButtonComponent, ChipComponent } from '@fms/ngx-layout';

import { FmsToggleFavoriteBtnComponent } from '../../components/toggle-favorite-button/toggle-favorite-button.component';

export interface FmsTextModalData {
	component$: Observable<DefaultSessionComponentFragment>;
	videoId: string;
	title: string;
	subTitle: string | string[];
}

@Component({
	selector: 'fms-text-modal',
	templateUrl: 'text-modal.component.html',
	styles: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		LetDirective,
		NzModalModule,
		NzDividerModule,
		MarkdownModule,
		ButtonComponent,
		ChipComponent,
		FmsToggleFavoriteBtnComponent,
	],
})
export class FmsTextModalComponent {
	readonly modalData = inject<FmsTextModalData>(NZ_MODAL_DATA);
	readonly #modalRef = inject(NzModalRef);
	showBelowFold = false;

	toggleBelowFoldContent() {
		this.showBelowFold = !this.showBelowFold;
	}

	async closeModal(): Promise<void> {
		// Component is already marked as seen
		this.#modalRef.destroy({ component$: this.modalData.component$ });
		return;
	}

	isArray(obj: unknown = null) {
		return Array.isArray(obj);
	}
}
